import { render, staticRenderFns } from "./DevGrid.vue?vue&type=template&id=183fbb88&scoped=true&"
import script from "./DevGrid.vue?vue&type=script&lang=ts&"
export * from "./DevGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DevGrid.vue?vue&type=style&index=0&id=183fbb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183fbb88",
  null
  
)

export default component.exports